import { useEffect, useState } from 'react';
import {
  buildAnswerKeyCanvas,
  outlineHasStoredAnswers,
} from '../../utils/worksheetAnswerKey';

/**
 * 정답지가 필요할 때만 개요로 교사용 쪽을 만든다.
 * 이미지 탭에서도 텍스트 개요를 쓴다.
 */
export default function useAnswerKeyPages(outline, key, enabled) {
  const [slides, setSlides] = useState([]);
  const [themeId, setThemeId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!enabled || !outlineHasStoredAnswers(outline)) {
      setSlides([]);
      setThemeId(null);
      return () => { cancelled = true; };
    }
    Promise.resolve(buildAnswerKeyCanvas({ outline }))
      .then((result) => {
        if (cancelled) return;
        setSlides(result?.slides || []);
        setThemeId(result?.outline?.canvas_theme || outline?.canvas_theme || null);
      })
      .catch(() => {
        if (!cancelled) {
          setSlides([]);
          setThemeId(null);
        }
      });
    return () => { cancelled = true; };
  }, [outline, key, enabled]);

  return { slides, themeId };
}
